
// vue
import { defineComponent, ref, computed } from 'vue';

// icons
import { add, close, arrowBack, } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonTitle, IonButtons, IonButton, IonIcon, IonToolbar,
        IonSegment, IonSegmentButton, IonContent, IonGrid, loadingController, } from '@ionic/vue';
import RolesInClassesModal from '@/components/teacher/RolesInClassesModal.vue';
import RoleInSchoolSelectModal from '@/components/teacher/RoleInSchoolSelectModal.vue';
import UserProfileFormModal from '@/components/modals/UserProfileFormModal.vue';

// utils
import config from '@/config';
import { useStore } from '@/store';
import { utils } from '@/composables/utils';
import { useRoute, useRouter } from 'vue-router';

// services
import AuthService from '@/services/AuthService';

// Firebase
import { customTokenSignin } from '@/auth';

export default defineComponent({
  name: 'TeacherRolesModal',
  props: ["isPage", "selectedRolesInSchool", "prefilledRolesInClasses"],
  components: {
    IonPage, IonHeader, IonTitle, IonButtons, IonButton, IonIcon, IonToolbar,
    IonSegment, IonSegmentButton, IonContent, IonGrid,
    RoleInSchoolSelectModal, RolesInClassesModal, UserProfileFormModal,
  },
  setup(props) {
    const selectedSection = ref("school");
    const { closeModal } = utils();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const { userId: paramUserId } = route.params;

    const checkPrefilledLogin = async (userId: any) => {
      const loading = await loadingController.create({ message: "Loading..." });
      await loading.present();
      try {
        const existingFirebaseUser = await AuthService.checkPhoneExists(null, userId, true);
        if (existingFirebaseUser && existingFirebaseUser.s == 200 && existingFirebaseUser.t) {
          await customTokenSignin(existingFirebaseUser.t);
        } else {
          store.commit('setLoadingUser', false);
          router.replace({ path: '/login', query: { redirectPath: '/update-roles' } });
        }
      } catch (e) {
        console.log(e);
      } finally {
        loading.dismiss();
      }
    }
    if (paramUserId) checkPrefilledLogin(paramUserId);

    return {
      // icons
      add, close, arrowBack,

      // variables
      selectedSection,

      // methods
      goBack: () => {
        if (props.isPage) router.replace('/home');
        else closeModal();
      },
    };
  },
});
